
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fredcon26",
      function () {
        return require("private-next-pages/fredcon26.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fredcon26"])
      });
    }
  